import { useEffect, useRef, useState } from 'react'
import { api } from '../api/client'

// useFleetVersion (ADR-101 Phase 1) — polls the commit SHA of MC's /fleet
// checkout so the Studio can react when published content changes under an open
// editor (via the ADR-100 timer or an ADR-101 webhook refresh). Returns the
// current SHA (empty until the first poll resolves). Poll failures are ignored —
// the previous value is kept, so a transient blip never triggers a false reload.
export function useFleetVersion(intervalMs = 5000): string {
  const [sha, setSha] = useState('')
  const shaRef = useRef('')

  useEffect(() => {
    let live = true
    const tick = async () => {
      try {
        const r = await api.fleetVersion()
        if (live && r.sha && r.sha !== shaRef.current) {
          shaRef.current = r.sha
          setSha(r.sha)
        }
      } catch {
        /* keep the last known SHA on a transient failure */
      }
    }
    void tick()
    const t = setInterval(() => { void tick() }, intervalMs)
    return () => { live = false; clearInterval(t) }
  }, [intervalMs])

  return sha
}
